import React, { FC, useCallback } from 'react'

import { RewardsQuery } from '../../../../../../../graphql/search'
import {
  setTierBenefitsModalState,
  useTierBenefitsModalState,
} from '../../../../../../../lib/rewards/tier-benefits-modal'
import { RewardsTierTable } from '../../../RewardsTierTable'
import * as Styled from './styled'

export interface RewardsTierModalProps {
  currentSnapshot?: NonNullable<
    NonNullable<RewardsQuery['customer']>['rewardsSnapshots']
  >['nodes'][number]
}

export const RewardsTierModal: FC<RewardsTierModalProps> = ({ currentSnapshot }) => {
  const { isOpen } = useTierBenefitsModalState()
  const closeModal = useCallback(() => setTierBenefitsModalState({ isOpen: false }), [])
  return (
    <Styled.Modal isOpen={isOpen} onBackgroundClick={closeModal} onEscapeKeydown={closeModal}>
      <Styled.CloseModalButtonLink onClick={closeModal}>
        <Styled.CloseIcon />
      </Styled.CloseModalButtonLink>
      <Styled.Content>
        <RewardsTierTable currentSnapshot={currentSnapshot} />
      </Styled.Content>
    </Styled.Modal>
  )
}
